import type { FC } from "react";

import {
  POLAROID_IMAGE_DEFAULTS,
  POLAROID_IMAGE_SIZE_CLASS_MAP,
  type TPolaroidImageProps,
} from "@/ui/components/primitives/PolaroidImage/PolaroidImage.config";
import { Container } from "@/ui/components/layout/Container";
import { AspectRatio } from "@/ui/components/primitives/AspectRatio";
import { Image } from "@/ui/components/primitives/Image";
import { cn } from "@/ui/lib/utils";

export const PolaroidImage: FC<TPolaroidImageProps> = ({
  image,
  rotation = POLAROID_IMAGE_DEFAULTS.rotation,
  size = POLAROID_IMAGE_DEFAULTS.size,
  className,
  ...props
}) => (
  <Container
    {...props}
    data-component="PolaroidImage"
    className={cn(
      "aspect-[9/10] border border-sys-grey-500 bg-sys-white shadow-lg",
      POLAROID_IMAGE_SIZE_CLASS_MAP[size],
      className,
    )}
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <AspectRatio ratio="1:1">
      <Image {...image} fit="cover" />
    </AspectRatio>
  </Container>
);

PolaroidImage.displayName = "PolaroidImage";
